import React from "react";
import { useTranslation } from "react-i18next";
import { indexStore } from "src/store/indexStore";
import { AlertDialogs } from "../Dialgos/Alter-Daylogs";
import EditOptionModel from "../pages/options/EditOptionModel";
import AddSubOptionModel from "../pages/options/subOption/AddSubOptionModel";
import { Plus } from "lucide-react";
import Iterator from "../utils/Iterator";
import SubOptionRow from "./SubOptionRow";
import { Skeleton } from "../ui/skeleton";
import { Card, CardContent, CardHeader } from "../ui/card";
import { Button } from "../ui/button";
import { Edit, Trash2, Settings, List } from "lucide-react";
import { Badge } from "../ui/badge";

export function OptionCard(props) {
  const { t } = useTranslation();
  const { deleteOptionFunction, setOption, nameLang } = indexStore();
  
  const onDelete = (id) => {
    deleteOptionFunction(id);
  };

  const editOption = (element) => {
    setOption(element);
  };

  return (
    <Card className="group hover:shadow-xl transition-all duration-300 overflow-hidden border-2 hover:border-primary/20 h-full flex flex-col" key={props.id}>
      <CardHeader className="pb-3 pt-6 px-6 bg-gradient-to-br from-primary/10 to-transparent border-b">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="p-2 rounded-lg bg-primary/20">
              <Settings className="w-5 h-5 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-bold text-foreground line-clamp-1">
                {props[nameLang] || t("gloabl.option")}
              </h3>
            </div>
          </div>
          {props.sub_options && props.sub_options.length > 0 && (
            <Badge variant="outline" className="ml-2">
              {props.sub_options.length} {t("gloabl.sub_option")}
            </Badge>
          )}
        </div>
      </CardHeader>

      <CardContent className="p-6 pt-4 flex flex-col flex-1">
        <div className="mb-4 flex-1">
          {props.sub_options && props.sub_options.length > 0 ? (
            <div className="space-y-2">
              <div className="flex items-center gap-2 mb-3">
                <List className="w-4 h-4 text-muted-foreground" />
                <span className="text-sm font-medium text-muted-foreground">
                  {t("gloabl.sub_options")}
                </span>
              </div>
              <div className="space-y-2">
                <Iterator
                  data={props.sub_options}
                  render={(e) => <SubOptionRow key={e.id} {...e} />}
                />
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-8 text-center text-muted-foreground border-2 border-dashed rounded-lg">
              <List className="w-8 h-8 mb-2 text-gray-300" />
              <p className="text-sm">{t("gloabl.no_sub_options") || "No sub-options yet"}</p>
            </div>
          )}
        </div>

        <div className="mt-auto pt-4 border-t space-y-2">
          <AddSubOptionModel
            option_id={props.id}
            trigger={
              <Button
                variant="outline"
                size="sm"
                className="w-full gap-2"
              >
                <Plus className="w-4 h-4" />
                {t("gloabl.add")} {t("gloabl.sub_option")}
              </Button>
            }
          />
          <div className="flex gap-2">
            <EditOptionModel
              trigger={
                <Button
                  variant="outline"
                  size="sm"
                  className="flex-1 gap-2"
                  onClick={() => editOption(props)}
                >
                  <Edit className="w-4 h-4" />
                  {t("gloabl.edit")}
                </Button>
              }
            />
            <AlertDialogs
              trigger={
                <Button
                  variant="destructive"
                  size="sm"
                  className="gap-2"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              }
              variant="icon"
              onClickOk={() => onDelete(props.id)}
              description={<span>{t("gloabl.deleteMessage")}</span>}
              title={`${t("gloabl.delete")} ${t("gloabl.option")}`}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export const OptionCardLoading = () => (
  <Card className="overflow-hidden border-2 h-full flex flex-col">
    <CardHeader className="pb-3 pt-6 px-6 bg-gradient-to-br from-primary/10 to-transparent border-b">
      <div className="flex items-center gap-3">
        <Skeleton className="w-9 h-9 rounded-lg" />
        <Skeleton className="h-5 flex-1" />
        <Skeleton className="w-16 h-6" />
      </div>
    </CardHeader>
    <CardContent className="p-6 pt-4 flex flex-col flex-1">
      <div className="space-y-2 mb-4 flex-1">
        <Skeleton className="h-4 w-24 mb-3" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
      <div className="pt-4 border-t space-y-2">
        <Skeleton className="h-9 w-full" />
        <div className="flex gap-2">
          <Skeleton className="h-9 flex-1" />
          <Skeleton className="w-9 h-9" />
        </div>
      </div>
    </CardContent>
  </Card>
);
